import { type ReactNode } from 'react'

export interface CellTabItem { key: string; label: string; count: number }

// One folder-style tab per commented cell of a row ("Halio × Shopee 2"),
// joined to the panel below. A cell picked in the table that has no comments
// yet shows "new". `trailing` sits right after the tabs (the Close button on
// the review page).
export default function CellTabBar({ tabs, active, onSelect, trailing }: {
  tabs: CellTabItem[]
  active: string | null
  onSelect: (key: string) => void
  trailing?: ReactNode
}) {
  return (
    <div className="flex items-end gap-1 border-b border-border px-2 pt-2" role="tablist">
      <div className="flex min-w-0 flex-wrap items-end gap-1">
        {tabs.map((t) => {
          const on = t.key === active
          return (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={on}
              onClick={() => onSelect(t.key)}
              className={`-mb-px inline-flex items-center gap-1.5 whitespace-nowrap rounded-t-md border border-b-0 px-3 py-1.5 text-[13px] text-foreground ${
                on ? 'border-border bg-background font-semibold' : 'border-transparent bg-muted/50 hover:bg-muted'
              }`}
            >
              {t.label}
              {t.count > 0
                ? <span className="rounded-full bg-primary/10 px-1.5 text-[11px] font-medium text-primary">{t.count}</span>
                : <span className="text-[11px] font-normal">new</span>}
            </button>
          )
        })}
      </div>
      {trailing && <div className="mb-1 ml-1">{trailing}</div>}
    </div>
  )
}
